import { type PaginatedDeployment } from "@/api/resources/deployments/types";
import { type DeploymentToWorkspace } from "@/supabase.types";
import { filterNotEmpty, sortObjectsBy } from "@/utils/format";

interface SelectorFilteredDeploymentsProps {
  currentWorkspaceId?: string;
  deployments: PaginatedDeployment[];
  deploymentsToWorkspaces: DeploymentToWorkspace[];
}
export const selectorFilteredDeployments = ({
  currentWorkspaceId,
  deployments,
  deploymentsToWorkspaces,
}: SelectorFilteredDeploymentsProps) => {
  const _deploymentsToWorkspaces = deploymentsToWorkspaces.filter((dtw) => dtw.workspace_id === currentWorkspaceId);

  const _deployments = deployments.filter((deployment) => deployment.workspace_id === currentWorkspaceId);
  const _sharedDeployments = _deploymentsToWorkspaces
    .map((dtw) => deployments.find((deployment) => deployment.id === dtw.deployment_id))
    .filter(filterNotEmpty);

  return [..._deployments, ..._sharedDeployments].sort(sortObjectsBy("name"));
};

interface SelectorCurrentDeploymentsProps {
  currentWorkspaceId?: string;
  deployments: PaginatedDeployment[];
}
export const selectorCurrentDeployments = ({ currentWorkspaceId, deployments }: SelectorCurrentDeploymentsProps) => {
  return deployments.filter(
    ({ workspace_id, deleted_at }) => workspace_id === currentWorkspaceId && deleted_at === null,
  );
};
